import axios from "axios";
import { musicClient, platformClient, authClient } from "@/lib/musicApi";

// Scoped bans: the server answers 403 {reason: "surface_banned", surface}. One plain message
// everywhere. Calls that show it inline pass {restrictedInline: true}; the rest get a toast.
export const restrictedText = (e, t) => {
  const d = e?.response?.data?.detail;
  if (d?.reason !== "surface_banned") return null;
  return t("errors.restricted", { area: t(`errors.area.${d.surface}`, { defaultValue: t("errors.area.default") }) });
};

let installed = false;
let last = { text: "", at: 0 };
export const installRestrictedToast = (toastError, t) => {
  if (installed) return;
  installed = true;
  const onErr = (err) => {
    const text = err?.config?.restrictedInline ? null : restrictedText(err, t);
    if (text && (text !== last.text || Date.now() - last.at > 4000)) {
      last = { text, at: Date.now() };
      toastError(text);
    }
    return Promise.reject(err);
  };
  [axios, musicClient, platformClient, authClient].forEach((c) => c && c.interceptors.response.use((r) => r, onErr));
};
